export default __webpack_public_path__ + "static/media/Snowing_05.8b01ddcd.png";